export const insertLinebreaks = (str: string, maxLength: number, maxLines: number) => {
  if (!str) return '';

  const resultArray: string[] = [];

  let acc = '';
  for (const word of str.split(/\s+/)) {
    if (acc.length + word.length + 1 <= maxLength || resultArray.length === maxLines - 1) {
      acc += acc.length ? ` ${word}` : word;
    } else {
      resultArray.push(acc);
      acc = word;
    }
  }
  resultArray.push(acc);

  return resultArray.join('\n');
};
